<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=5000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container >
            <div>
                <v-row>
                    <v-col>
                        <h1>Accueil client sans rendez-vous</h1>
                    </v-col>
                </v-row>
                <v-row class="pl-8 pr-8" v-if="!haveResult">
                    <v-col>
                        <v-text-field v-model="chassis" label="Entrer un numéro de châssis" hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="2" v-if="chassis != false && chassis != ''">
                        <v-btn :disabled="loading" class="ml-6" color="primary" dark @click="searchChassis">Rechercher</v-btn>
                    </v-col>
                </v-row>
                <v-row class="pl-8 pr-8 mt-10" v-if="haveResult">
                    <v-col>
                        <v-simple-table class="text-left">
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td width="25%">Client</td>
                                        <td>{{ client.nomtitulaire}}</td>
                                    </tr>
                                    <tr>
                                        <td>Châssis</td>
                                        <td>{{ client.chassis }}</td>
                                    </tr>
                                    <tr>
                                        <td>Matricule</td>
                                        <td>{{ client.matricule }}</td>
                                    </tr>
                                    <tr>
                                        <td>Numéro WW</td>
                                        <td>{{ client.numww }}</td>
                                    </tr>
                                    <tr>
                                        <td>Téléphone</td>
                                        <td>{{ client.tel }}</td>
                                    </tr>
                                    <tr>
                                        <td>Mail</td>
                                        <td>{{ client.mail }}</td>
                                    </tr>
                                    <tr>
                                        <td>Modèle</td>
                                        <td>{{ client.modele}}</td>
                                    </tr>
                                    <tr>
                                        <td>Intervention demandée</td>
                                        <td>
                                            <v-select
                                                    :items="client.interventions"
                                                    item-text="name"
                                                    item-value="id"
                                                    v-model="client.intervention"
                                                    label="Sélectionner l'intervention a réaliser"
                                                    solo
                                                    class="mt-4"
                                                    style="text-align:left"
                                            ></v-select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center">
                                            <v-btn class="mt-10" v-if="client.intervention != false" x-large color="primary" dark @click="saveRdv(client)">Faire entrer le véhicule</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-app>
</template>

<script>
    import NProgress from "nprogress";

    export default {
        name : 'AddRdv',
        data() {
            return {
                loading: false,
                chassis: '',
                model: false,
                snackbar: false,
                errorMsg: '',
                client: {},
                haveResult: false
            }
        },
        methods: {
            saveRdv(rdv){
                if(confirm("Etes vous sur de vouloir créer cette entrée ?")) {
                    NProgress.start()
                    this.loading = true
                    let params = {}
                    params.action = 'saveRdv'
                    params.rdv = rdv

                    this.axios
                        .post(this.$store.state.rootUrl + 'apiv1.php', params, {timeout: 10000})
                        .then(({data}) => {
                            NProgress.done()
                            this.loading = false
                            if (data.error === true) {
                                console.log(data.data)
                                this.errorMsg = 'Impossible d\'enregistrer votre rendez-vous. Vérifier votre connexion !'
                                this.snackbar = true
                                return false
                            }
                            if (data.data === false) {
                                this.loading = false
                                this.errorMsg = 'Erreur lors de la sauvegarde du rendez-vous !'
                                this.snackbar = true
                                return false
                            }
                            this.loading = false
                            this.$router.push({name:'ListeRdv'})
                        })
                        .catch((error) => {
                            NProgress.done()
                            this.loading = false
                            console.log(error)
                            this.errorMsg = 'Impossible de contacter le serveur. Vérifier votre connexion !'
                            this.snackbar = true
                            this.loading = false
                        })
                }
            },
            searchChassis() {
                NProgress.start()
                this.loading = true
                let params = {}
                params.action = 'searchChassis'
                params.chassis = this.chassis

                this.axios
                    .post(this.$store.state.rootUrl + 'apiv1.php', params, {timeout: 10000})
                    .then(({data}) => {
                        NProgress.done()
                        this.loading = false
                        if (data.error === true) {
                            console.log(data.data)
                            this.errorMsg = 'Impossible d\'effectuer une recherche. Vérifier votre connexion !'
                            this.snackbar = true
                            return false
                        }
                        if (data.data.length == 0){
                            this.loading = false
                            this.errorMsg = 'Aucun client ne correspond à ce châssis ! Si vous ne trouvez pas, demandez au conseiller service de créer le client et le rendez-vous '
                            this.snackbar = true
                            return false
                        }
                        this.haveResult = true
                        this.client = data.data[0]
                        this.loading = false
                    })
                    .catch((error) => {
                        NProgress.done()
                        this.loading = false
                        console.log(error)
                        this.errorMsg = 'Impossible de contacter le serveur. Vérifier votre connexion !'
                        this.snackbar = true
                        this.loading = false
                    })
            }
        },
    }
</script>

<style scoped>

</style>
